<template>
    <div :class="'ui label basic red ' + pointing" v-if="error && error.length > 0">
        <span v-if="error.length === 1">{{error[0]}}</span>
        <ul v-if="error.length > 1">
            <li v-for="err in error">{{err}}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: ['error', 'direction'],
        computed: {
            pointing(){
                if(this.direction === 'below') return 'pointing below';
                if(['left','right'].includes(this.direction)) return this.direction + ' pointing';
                return 'pointing';
            }
        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/errorTag.vue